import { AppConfig } from '../app/core/config/app-config';

/**
 * Resolve the RIPT API base URL from the browser host at runtime so a single
 * production bundle can be deployed to every environment (the Chevron ADO
 * pipeline runs one `ng build` and ships the same artifact per env). Matching
 * uses the `-dev` / `-test` host suffixes (dev FE is `dewittesting-dev.…`, which
 * has no `-test` substring, so dev must be checked before test); anything else
 * that isn't localhost is treated as production.
 */
function resolveApiBaseUrl(): string {
  const host = (typeof window !== 'undefined' ? window.location.hostname : '').toLowerCase();
  if (host === 'localhost' || host === '127.0.0.1' || host === '') {
    return 'https://localhost:44365/api/v1';
  }
  if (host.includes('-dev')) {
    return 'https://dewit-dev.azure.chevron.com/api/v1';
  }
  if (host.includes('-test')) {
    return 'https://dewit-test.azure.chevron.com/api/v1';
  }
  return 'https://dewit-prod.azure.chevron.com/api/v1';
}

/**
 * Build-time bootstrap configuration. Non-secret values only — the API base URL is
 * a same-origin relative path and the Entra client/tenant ids are public identifiers.
 * Access tokens and secrets are never stored here (NFR-16); they are acquired at
 * runtime via MSAL / resolved server-side from Key Vault.
 *
 * ⚠ SMOKE-TEST config — mirrors EPCC's proven MSAL wiring
 * (`EPCC/Angular/src/environments/environment.dev.ts` + `EPCC/API/NetCore.API/Startup.cs`).
 * The `clientId` and `apiScopes` below are borrowed from EPCC to validate the MSAL
 * sign-in / bearer-token flow end-to-end against the Chevron tenant. Tokens minted this
 * way are issued for EPCC's app registration — REPLACE with a dedicated RIPT app
 * registration (Chevron-tenant, URL-form Application ID URI + `user_impersonation`
 * scope) before any non-local deployment.
 */
export const environment: AppConfig = {
  production: true,
  // Resolved at runtime from the browser host (see resolveApiBaseUrl above) so the
  // same bundle can target local / dev / test / prod without per-env builds.
  apiBaseUrl: resolveApiBaseUrl(),
  authEnabled: true,
  auth: {
    // DEW-IT v2 - test Chevron-tenant app registration.
    clientId: '773ec112-a5e2-4f00-a48b-94bbb6c89a1d',
    // Chevron tenant domain — MSAL accepts either the tenant GUID or the verified domain.
    // Matches EPCC's authority: `https://login.windows.net/chevron.onmicrosoft.com`.
    tenantId: 'chevron.onmicrosoft.com',
    redirectUri: '/',
    postLogoutRedirectUri: '/',
    // Fully-qualified URL-form scope matching the app registration's Application ID URI
    // (`https://dewit-test.azure.chevron.com`) + the enabled scope (`user_impersonation`).
    apiScopes: ['https://dewit-test.azure.chevron.com/user_impersonation'],
  },
  appInsights: {
    connectionString: '',
  },
};
